export default {
  namespaced: true,
  state: {
    show: false
  },

  getters: {
    ifShow: state => state.show
  },

  mutations: {
    SHOW_TOUR(state, value) {
      state.show = value
    },
  },

  actions: {
    async updateHandler({commit, dispatch}, tour) {
      let res = dispatch('api/users/updateShowTour', tour, {root: true})
      if(!(await res)?.success) console.error("showTour failed to update")
      else commit('current_user/USER', {showTour: tour}, {root: true}) //update user so client + api data matches
      dispatch('updateHandlerCallback', tour)
    },
    async updateHandlerCallback({rootGetters, commit, dispatch}, tour) {
      commit('SHOW_TOUR', tour)
      //if clicking show tour from settings, etc
      if(rootGetters['routing/routeName'] !== 'area' && tour) dispatch('routing/goToCurrentArea', null, {root: true})
    },

    async updateOnLoad({rootGetters, getters, dispatch}) {
      await dispatch('updateHandlerCallback', rootGetters['current_user/showTour'])
      if(!getters.ifShow) dispatch('remindLaterCheck')
    },

    async remindLaterHandler() {
      localStorage.setItem('tourRemindLater', true)
    },
    async remindLaterCheck({dispatch}) {
      let isInStorage = localStorage.getItem('tourRemindLater', false)
      if(isInStorage) {
        localStorage.removeItem('tourRemindLater')
        dispatch('updateHandler', true)
      }
    }
  }
};
